/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleHistogramSeriesViewBucket } from './SingleHistogramSeriesViewBucket';
import {
    SingleHistogramSeriesViewBucketFromJSON,
    SingleHistogramSeriesViewBucketFromJSONTyped,
    SingleHistogramSeriesViewBucketToJSON,
} from './SingleHistogramSeriesViewBucket';

/**
 * 
 * @export
 * @interface HistogramValues
 */
export interface HistogramValues {
    /**
     * 
     * @type {SingleHistogramSeriesViewBucket}
     * @memberof HistogramValues
     */
    bucket: SingleHistogramSeriesViewBucket;
    /**
     * 
     * @type {Array<number>}
     * @memberof HistogramValues
     */
    values: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof HistogramValues
     */
    x: number;
}

/**
 * Check if a given object implements the HistogramValues interface.
 */
export function instanceOfHistogramValues(value: object): value is HistogramValues {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    return true;
}

export function HistogramValuesFromJSON(json: any): HistogramValues {
    return HistogramValuesFromJSONTyped(json, false);
}

export function HistogramValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistogramValues {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': SingleHistogramSeriesViewBucketFromJSON(json['bucket']),
        'values': json['values'],
        'x': json['x'],
    };
}

export function HistogramValuesToJSON(value?: HistogramValues | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bucket': SingleHistogramSeriesViewBucketToJSON(value['bucket']),
        'values': value['values'],
        'x': value['x'],
    };
}

